// extracted by mini-css-extract-plugin
export default {"tooltip":"TX-z","arrow":"UX-z"};